import { render, staticRenderFns } from "./pro-drawer.vue?vue&type=template&id=f5742976&scoped=true"
import script from "./pro-drawer.vue?vue&type=script&lang=js"
export * from "./pro-drawer.vue?vue&type=script&lang=js"
import style0 from "./pro-drawer.vue?vue&type=style&index=0&id=f5742976&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5742976",
  null
  
)

export default component.exports